import { render, staticRenderFns } from "./LyricsAsideDialog.vue?vue&type=template&id=bc7d2b90&scoped=true&"
import script from "./LyricsAsideDialog.vue?vue&type=script&lang=js&"
export * from "./LyricsAsideDialog.vue?vue&type=script&lang=js&"
import style0 from "./LyricsAsideDialog.vue?vue&type=style&index=0&id=bc7d2b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7d2b90",
  null
  
)

export default component.exports